import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import notificationsSlice from 'app/store/notificationsSlice';
import { useNotificationsAllQuery } from 'src/app/queries/notifications.queries';
import { useStore } from 'zustand';

function NotificationPanelToggleButton() {
  const state = useStore(notificationsSlice);
  const { data: notificationsResult } = useNotificationsAllQuery();
  const notifications = notificationsResult?.data.items || [];
  const hasUnread = notifications.some((n) => !n.read);

  return (
    <IconButton
      className="w-40 h-40"
      onClick={(ev) => state.toggleNotificationPanel()}
      size="large"
    >
      <Badge color="secondary" variant="dot" invisible={!hasUnread}>
        <FuseSvgIcon>heroicons-outline:bell</FuseSvgIcon>
      </Badge>
    </IconButton>
  );
}

export default NotificationPanelToggleButton;
